import React, { useRef } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import UploadFileIcon from '@mui/icons-material/UploadFile';// import { useRef } from "react";
import DescriptionIcon from '@mui/icons-material/Description';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadingIcon from '@mui/icons-material/Downloading';
import HelpIcon from '@mui/icons-material/Help';

const SpeechText = () => {
  // Create a reference for the file input
  const fileInputRef = useRef(null);

  // Function to handle button click and open file input dialog
  const handleUploadClick = () => {
    fileInputRef.current.click(); // Trigger click on input type="file"
  };

  // Function to handle file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    console.log("Selected file:", file);
  };

  return (
    <>
      <div className="px-4 py-6">
        <div className="p-[14px] shadow-cs rounded-lg mb-[20px] bg-white">
          <h1 className="text-[16px] md:text-[18px] cursor-pointer font-medium text-gray-900 mb-2">
            Speech to text
          </h1>
          <div className="flex items-center text-sm text-gray-500">
            <a href="/" className="hover:text-gray-700">
              Home
            </a>
            <span className="mx-2">
              <ChevronRightIcon />
            </span>
            <span className="text-gray-700">Image Genrator</span>
          </div>
        </div>
        <div className=" flex items-center justify-between flex-wrap gap-[14px] md:gap-[0] mb-[20px]">
          <div className="flex items-center md:gap-[16px] gap-[10px]">
            <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium   rounded-2xl shadow-cs bg-white text-[11px] md:text-[14px] text-[#8125b0]">
             <HelpIcon className="icons-crm"/> geminiAi: 99157
            </button>
            <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium  rounded-2xl shadow-cs bg-white text-[11px] md:text-[14px] text-[#008000]">
          <HelpIcon className="icons-crm"/>  OpenAi: 76904
            </button>
          </div>
        </div>
        <div className="p-[16px] shadow-cs rounded-lg bg-white mb-[20px]">
          <div className="flex items-center justify-between flex-wrap gap-[10px]">
            <div className=" gap-[10px]   flex items-center md:gap-[14px]">
              <button className="  rounded-2xl whitespace-nowrap text-[11px] md:text-[14px] pl-[18px] pr-[18px] font-medium pt-[5px] pb-[5px] shadow-cs text-black"  >
                Text
              </button>
              <button className="rounded-2xl pl-[18px] whitespace-nowrap text-[11px] md:text-[14px] font-medium pr-[18px] pt-[5px] pb-[5px] shadow-cs text-black ">
                Words with timestamp
              </button>
              <div>
                {/* Hidden file input */}
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: "none" }} // Hide the input element
                />
                {/* Button to open the file input dialog */}
                <button type="button" onClick={handleUploadClick}>
                  <UploadFileIcon className="text-[#27004a]"/>
                </button>
              </div>
            </div>
            <button className="second-btn">Genrate Speech</button>
          </div>
        </div>
        {/* Document List */}
        <div className="space-y-4">
          {[1, 2].map((item) => (
            <div
              key={item}
              className="flex items-center justify-between p-4 bg-white rounded-lg shadow-cs"
            >
              <div className="flex items-center gap-4">
                <div className="p-2 bg-gray-100 rounded">
             <DescriptionIcon className="text-[#27004a]"/>
                </div>
                <div>
                  <p className="  text-[14px] md:font-medium md:text-[15px] ">1 months ago</p>
                  <p className="text-sm text-gray-600">Text</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <button className="p-2 text-gray-600 hover:text-gray-800 transition-colors">
              <DeleteOutlineIcon/>
                </button>
                <button className="p-2 text-gray-600 hover:text-gray-800 transition-colors">
              <DownloadingIcon/>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default SpeechText;
